module.exports = __webpack_public_path__ + "static/media/apiMerah.f2c3a696.svg";